import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import { useHeartbeat } from '@/hooks/use-heartbeat'
import { Toaster } from '@/components/ui/sonner'
import { NavigationProgress } from '@/components/navigation-progress'
import { TempLoginBanner } from '@/components/temp-login-banner'
import GeneralError from '@/features/errors/general-error'
import NotFoundError from '@/features/errors/not-found-error'

export const Route = createRootRouteWithContext()({
  head: () => ({ meta: [{ title: APP_NAME }] }),
  component: () => <TheComponent />,
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})

const TheComponent = () => {
  useHeartbeat(30_000)
  return (
    <>
      <HeadContent />
      <NavigationProgress />
      <TempLoginBanner />
      <Outlet />
      <Toaster
        duration={2500}
        richColors
        position='top-center'
        toastOptions={{ classNames: { title: '!font-semibold !text-base' } }}
      />
    </>
  )
}
